import { useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import GrainOverlay from "../components/GrainOverlay";

const Section = ({ title, children, testId }) => (
  <div className="mt-14 first:mt-0" data-testid={testId}>
    <h2 className="h-display text-2xl md:text-3xl mb-4 text-ink">{title}</h2>
    <div className="space-y-4 text-base md:text-lg leading-relaxed text-ink/80">
      {children}
    </div>
  </div>
);

export default function DataDeletion() {
  useEffect(() => {
    document.title = "Data Deletion Instructions | GoneSoon";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="data-deletion-page" className="relative">
      <GrainOverlay />
      <div className="bg-cream">
        <Nav variant="cream" />
      </div>

      <section className="bg-cream text-ink">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-10">
          <div className="pill text-ink/70 border-ink/20 mb-8">
            <span className="pill-dot" />
            Legal
          </div>
          <h1 data-testid="data-deletion-headline" className="h-display text-[2.5rem] md:text-[4rem] leading-[0.95] max-w-[20ch]">
            Data Deletion Instructions
          </h1>
          <p className="mt-6 text-ink/60 text-sm uppercase tracking-[0.18em]">
            Effective August 3, 2026
          </p>
        </div>

        <div className="max-w-[900px] mx-auto px-6 md:px-10 pb-24 md:pb-32">
          <Section title="How to request deletion" testId="deletion-how-to">
            <p>
              To request deletion of your GoneSoon account and the personal data associated with
              it, email us at{" "}
              <a href="mailto:privacy@gonesoon.in" className="ed-link text-ink">privacy@gonesoon.in</a>{" "}
              from any email address, with the subject line "Delete my data," and include the
              mobile number registered on your account so we can find and verify it.
            </p>
            <p>
              Alternatively, you can send a WhatsApp message to our business number requesting
              account deletion — include the same mobile number the request is coming from.
            </p>
          </Section>

          <Section title="What gets deleted" testId="deletion-what">
            <p>
              Once verified, we delete your account profile (name and mobile number), your
              membership/subscription status, and your claim and redemption history. If you had
              previously messaged us on WhatsApp as a prospective merchant, we also delete the
              related onboarding conversation and lead records tied to your number.
            </p>
          </Section>

          <Section title="Timeframe" testId="deletion-timeframe">
            <p>
              We process verified deletion requests within 30 days. We may retain limited
              information where required to comply with a legal obligation, resolve disputes, or
              enforce our agreements, for no longer than necessary for that purpose.
            </p>
          </Section>

          <Section title="Questions" testId="deletion-contact">
            <p>
              For anything else about how we handle your data, see our{" "}
              <Link to="/privacy" className="ed-link text-ink">Privacy Policy</Link>, or email{" "}
              <a href="mailto:privacy@gonesoon.in" className="ed-link text-ink">privacy@gonesoon.in</a>.
            </p>
          </Section>
        </div>
      </section>

      <Footer />
    </div>
  );
}
